import { sessionStorageUtil } from "../utils/storage";

export const setFunds = async () => {
  try {
    await fetch(`${process.env.REACT_APP_API_URL}/funds`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      // body: JSON.stringify(dummyFundsData)
    });
  } catch (error) {
    throw new Error("error updating funds ...");
  }
};

export const getFunds = async (updateFunds, updateVisible) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/funds?limit=1000`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("error during fetch operation ...");
    }

    const data = await response.json();

    // if (params.category) {
    // 	if (params.category === 'shariah') {
    // 		// add shariah compliant funds
    // 	} else {
    // 		// add non-shariah compliant funds
    // 	}
    // }

    updateFunds(data.results);

    if (updateVisible !== null && updateVisible !== undefined) {
      updateVisible(data.results.slice(0, 20));
    }
  } catch (error) {
    // handle error
  }
};

export const sendInvestorRequest = async (data) => {
  const token = sessionStorageUtil.getAccessToken();
  const code = sessionStorageUtil.getAmcCode();

  // console.log(data);

  // console.log(typeof data.units_requests);

  const formData = new FormData();

  formData.append("amc_code", code);

  for (const [key, value] of Object.entries(data)) {
    if (key === "payment_proof_file" && value === null) {
      continue;
    }

    if (key === "tax_calculations") {
      formData.append(key, JSON.stringify(value))
      continue;
    }

    formData.append(key, value);
  }

  formData.forEach((value, key) => {
    // console.log(key, value);
  });

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/investor-requests`, {
      method: "POST",
      headers: {
        Authorization: token,
      },
      body: formData,
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok && data?.status === 409) {
      return {
        error: true,
        ...data
      }
    }

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message);
    }

    return {
      data: data?.data,
      message: data.message,
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      data: null,
      message: error?.message,
      error: true,
    };
  }
};

export const updatePaymentProof = async (data) => {
  const token = sessionStorageUtil.getAccessToken();
  const code = sessionStorageUtil.getAmcCode();

  // console.log(data);

  const formData = new FormData();

  formData.append("amc_code", code);

  for (const [key, value] of Object.entries(data)) {
    // if (key === "payment_proof_file" && value === null) {
    //     continue;
    // }

    formData.append(key, value);
  }

  formData.forEach((value, key) => {
    // console.log(key, value);
  });

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/investor-requests/update-payment-proof`, {
      method: "POST",
      headers: {
        Authorization: token,
      },
      body: formData,
    });

    const data = await response.json();

    // console.log(data);

    if (!response.ok || data?.status !== 200) {
      throw new Error(data?.message);
    }

    return {
      message: data.message,
      error: false,
    };
  } catch (error) {
    // console.log(error);

    return {
      message: error?.message,
      error: true,
    };
  }
};
